import { render, staticRenderFns } from "./BetStats.vue?vue&type=template&id=17ba9148&scoped=true"
import script from "./BetStats.vue?vue&type=script&lang=js"
export * from "./BetStats.vue?vue&type=script&lang=js"
import style0 from "./BetStats.vue?vue&type=style&index=0&id=17ba9148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ba9148",
  null
  
)

export default component.exports